import LoginForm from './components/LoginForm'
import { Link } from 'react-router-dom'

export default function Login() {
  return (
    <div className="min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex">

      {/* Left Panel — hidden on mobile */}
      <div className="hidden lg:flex w-1/2 bg-gradient-to-br from-green-950 to-black flex-col justify-center px-16 border-r border-white/10">
        <div className="mb-8">
          <Link to="/" className="flex items-center gap-3 mb-16">
            <img src="/Mufulira_Wanderers_logo.png" alt="Mufulira Wanderers" className="w-8 h-8 object-contain" />
            <span className="font-black tracking-widest uppercase text-lg text-white">MWFC</span>
          </Link>
          <h1 className="text-5xl font-black uppercase leading-none tracking-tight mb-6 text-white">
            Welcome<br />
            <span className="text-green-500">Back.</span>
          </h1>
          <p className="text-gray-400 leading-relaxed max-w-sm">
            Sign in to access your membership, track fixtures, and stay connected with your club community.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          {[
            'Access your digital membership card',
            'Track your subscription status',
            'Stay updated with fixtures and results',
            'Support members through welfare campaigns',
          ].map((item) => (
            <div key={item} className="flex items-center gap-3">
              <div className="w-1.5 h-1.5 bg-green-500 rounded-full" />
              <span className="text-gray-400 text-sm">{item}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Right Panel - Form */}
      <div className="flex-1 flex flex-col justify-center px-4 sm:px-8 lg:px-16 py-10 bg-white dark:bg-black">
        <div className="max-w-md w-full mx-auto">

          {/* Mobile logo */}
          <div className="flex lg:hidden items-center gap-3 mb-8">
            <img src="/Mufulira_Wanderers_logo.png" alt="Mufulira Wanderers" className="w-8 h-8 object-contain" />
            <span className="font-black text-gray-900 dark:text-white tracking-widest uppercase">MWFC</span>
          </div>

          <div className="mb-8 lg:mb-10">
            <h2 className="text-2xl sm:text-3xl font-black uppercase tracking-tight mb-2 text-gray-900 dark:text-white">
              Sign In
            </h2>
            <p className="text-gray-500 text-sm">Enter your credentials to continue</p>
          </div>
          <LoginForm />
          <p className="text-center text-gray-500 text-sm mt-6">
            Don't have an account?{' '}
            <Link to="/register" className="text-green-600 dark:text-green-400 hover:text-green-700 dark:hover:text-green-300 font-semibold">
              Register here
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}